const BANK_SETUP_PATH = /\/bank-setup\/[^/?#]+/gi;
const BANK_SETUP_HASH = /(\/bank-setup(?:\/)?)#[^?\s]*/gi;

export const redactSensitiveAppUrl = (url: string): string =>
  url.replace(BANK_SETUP_PATH, '/bank-setup/[redacted]').replace(BANK_SETUP_HASH, '$1#[redacted]');

type SentryBreadcrumb = {
  data?: { url?: string };
  message?: string;
};

export type SentryEventLike = {
  request?: { url?: string };
  transaction?: string;
  breadcrumbs?: SentryBreadcrumb[];
};

export const redactSentryEventUrls = <T extends SentryEventLike>(event: T): T => {
  if (event.request?.url) {
    event.request.url = redactSensitiveAppUrl(event.request.url);
  }
  if (event.transaction) {
    event.transaction = redactSensitiveAppUrl(event.transaction);
  }
  for (const crumb of event.breadcrumbs ?? []) {
    if (crumb.data?.url) {
      crumb.data.url = redactSensitiveAppUrl(crumb.data.url);
    }
    if (crumb.message) {
      crumb.message = redactSensitiveAppUrl(crumb.message);
    }
  }
  return event;
};

export const redactPosthogProperties = (
  properties: Record<string, unknown>,
): Record<string, unknown> => {
  const currentUrl = properties.$current_url;
  if (typeof currentUrl === 'string') {
    properties.$current_url = redactSensitiveAppUrl(currentUrl);
  }
  const pathname = properties.$pathname;
  if (typeof pathname === 'string') {
    properties.$pathname = redactSensitiveAppUrl(pathname);
  }
  return properties;
};
